import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

// https://netbasal.com/disabling-form-controls-when-working-with-reactive-forms-in-angular-549dd7b42110
@Directive({
  selector: '[disableControl]',
})
export class DisableControlDirective {
  @Input() set disableControl(condition: boolean) {
    const action: string = condition ? 'disable' : 'enable';
    this.ngControl.control[action]();
  }

  constructor(private ngControl: NgControl) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/disable-control.directive.ts